module.exports = __webpack_public_path__ + "img/img_036@2x.7dcb309a.png";